import Axios from 'axios';

const defaultCredits = () => ({
  daDollarsStandard: 0,
  daNtarltarStandard: 0,
  piPartIdentification: 0,
  viVehicleIdentification: 0,
});

const normalizeCredits = (credits = {}) => {
  const normalized = defaultCredits();
  Object.keys(normalized).forEach((key) => {
    const value = Number(credits[key]);
    normalized[key] = Number.isFinite(value) ? value : 0;
  });
  return normalized;
};

const state = () => ({
  aiCredits: defaultCredits(),
});

const mutations = {
  setCredits(state, aiCredits = {}) {
    state.aiCredits = normalizeCredits(aiCredits);
  },
};

const actions = {
  async getAiCredits({ commit }) {
    try {
      const resp = await Axios({
        url: '/fe/ai-credits',
        method: 'GET',
      });

      if (resp.data && resp.data._status === true) {
        commit('setCredits', resp.data.aiCredits);
      } else {
        commit('setCredits', defaultCredits());
      }
    } catch (err) {
      console.error('getAiCredits error:', err);
      commit('setCredits', defaultCredits());
    }
  },
};

const getters = {
  hasCredits: (state) =>
    Object.values(state.aiCredits || {}).some((v) => Number(v) > 0),
  hasZeroCredits: (state) =>
    Object.values(state.aiCredits || {}).some((v) => Number(v) === 0),
  aiCredits: (state) => state.aiCredits,
  hasDaDollarsStandard: (state) =>
    Number(state.aiCredits?.daDollarsStandard) > 0,
  hasDaNtarltarStandard: (state) =>
    Number(state.aiCredits?.daNtarltarStandard) > 0,
  hasPiPartIdentification: (state) =>
    Number(state.aiCredits?.piPartIdentification) > 0,
  hasViVehicleIdentification: (state) =>
    Number(state.aiCredits?.viVehicleIdentification) > 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
